import React, { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import banner from "../../Assets/Images/BackgroundPopup.jpg";
import '../../Assets/Styles/Customer/font-size.css';

export default function InfoPopup() {
  const [open, setOpen] = useState(true);

  return (
    <Modal
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      aria-labelledby="info-popup"
      sx={{
        backdropFilter: "blur(2px)",
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.6)",
        },
      }}
    >
      {/* WRAPPER – size comes from image */}
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          outline: "none",
        }}
      >
        {/* IMAGE CONTAINER */}
        <Box sx={{ position: "relative" }}>
          {/* IMAGE */}
          <Box
            component="img"
            src={banner}
            alt="myPHL"
            sx={{
              display: "block",
              maxWidth: "50vw",
              maxHeight: "40vh",
              width: "auto",
              height: "auto",
              borderRadius: 2,
            }}
          />

          {/* CLOSE BUTTON */}
          <IconButton
            size="small"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#333",
              backgroundColor: "rgba(255,255,255,0.6)",
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          {/* TEXT INSIDE IMAGE (RIGHT SIDE) */}
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              right: "6%",
              transform: "translateY(-50%)",
              width: "40%",
              color: "#1f2a37",
              lineHeight: 1.4,
              textAlign: "center"
            }}
          >
            <Box className="description-small-customer">
              Tải ngay ứng dụng
            </Box>

            <Box className="title-popup-customer"
              sx={{
                fontWeight: 700,
              }}
            >
              myPHL
            </Box>

            <Box>
              <a className="description-small-customer"
                href={process.env.REACT_APP_INSTALL_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#1e88e5",
                  fontWeight: 600,
                  textDecoration: "underline",
                }}
              >
                TẠI ĐÂY
              </a>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
